import clsx from "clsx";
import { useAtomValue, useSetAtom } from "jotai";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { ToastContainer } from "react-toastify";
import {
  animationsAtom,
  appConfig,
  currentTheme,
  hideToastNotificationsAtom,
  selectedSectionAtom,
  smetaStore,
  smetaWebSocket,
} from "../../atoms";
import { SmetaResizeElement } from "../ComponentInterface";
import { setClientInfo } from "../Singin/SingIn";
import { CheckModalBackGrounds } from "../TokenProcessing/TokenProcessing";
import { getOptionsForUser, updateOptionsForUser } from "../Url";
import StickyFooter, { HideAllFooterData } from "./NotWorkArea(Side&Head)/Footer";
import DashboardNavbar, { execABLProgram } from "./NotWorkArea(Side&Head)/Header/Header";
import { openHelpContextDialog } from "./NotWorkArea(Side&Head)/Header/SupportButton";
import SideBar from "./NotWorkArea(Side&Head)/SideBar/SideBar";
import { smetaModals } from "./Tools/modalManager";
import SplitterLocal from "./Tools/Splitter";
import { getIntervalActualVersionWebsite, updateGridData } from "./Tools/Tools";
import FullRightSide from "./Windows/FullRightSide";
import wrapperStyles from "./wrapperMainFile.module.css";
import { WebSocketClient } from "../smetaWebSocket";

export const hideSnow = (show = false) => {
  const enableSnowEffect = smetaStore.get(appConfig).smeta.signOptions?.snowEffect;
  if (show && !enableSnowEffect) return hideSnow();
  const snowflakes = document.querySelector(".snowflakes-box");

  const snowball = document.querySelector(".snowball-box");
  const display = show ? "block" : "none";
  if (snowflakes) snowflakes.style.display = display;
  if (snowball) snowball.style.display = display;
};

export default function WrapperRightSide(props: any) {
  const theme = useAtomValue(currentTheme);
  const setSmetaWebSocket = useSetAtom(smetaWebSocket);
  const animations = useAtomValue(animationsAtom);
  const {
    smeta: { homeOptions },
  } = useAtomValue(appConfig);
  const headerHeight = homeOptions?.header?.height;
  const sideBarSelected = useAtomValue(selectedSectionAtom);
  const [drawerOpen, setdrawerOpen] = useState(
    getOptionsForUser()?.drawerOpen === undefined ? false : getOptionsForUser()?.drawerOpen,
  );
  const hideToastNotifications = useAtomValue(hideToastNotificationsAtom);

  useEffect(() => {
    updateGridData(150).then(() => {
      if (sideBarSelected && sideBarSelected.ID !== "") {
        HideAllFooterData(sideBarSelected.ID);
      }
    });
  }, [sideBarSelected]);

  function showMenu() {
    setdrawerOpen(!drawerOpen);
    updateOptionsForUser({ drawerOpen: !drawerOpen });
    if (animations) {
      updateGridData(501);
    } else updateGridData(251);
  }

  function onResizeEnd() {
    updateGridData();
  }

  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const key = event.key;
    const keys: { [key: string]: () => void } = {
      F1: openHelpContextDialog,
    };
    if (CheckModalBackGrounds() === 0) {
      if (key in keys) {
        event.preventDefault();
        keys[key]();
      }
    }
    event.stopPropagation();
  };

  const setInfo = async () => {
    const json = await setClientInfo();
    const { ProgID: progId } = json;
    if (progId) {
      const command = {
        module: "tools",
        params: {
          ProgID: progId,
        },
      };
      execABLProgram({ command });
    }
  };

  useLayoutEffect(() => {
    document.title = "Web-Смета";
    hideSnow();
    setInfo();
    const ws = new WebSocketClient();
    setSmetaWebSocket(ws);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(timer!);
      const timout = setTimeout(() => {
        document.querySelectorAll("[data-smetaresizer]").forEach((el) => {
          if (el.checkVisibility()) (el as SmetaResizeElement).resize();
        });
        smetaModals.refreshMinimizedWindowsPosition(
          Array.from(document.querySelectorAll<HTMLDivElement>(".modalWindow[minimized]")),
        );
        updateGridData();
      }, 250);
      setTimer(timout);
    };
    window.addEventListener("resize", handleResize);
    const intervalGetActualVersionWebsite = getIntervalActualVersionWebsite();
    return () => {
      window.removeEventListener("resize", handleResize);
      clearInterval(intervalGetActualVersionWebsite);
    };
  }, []);

  return (
    <div className={clsx(wrapperStyles["div-wrapper"])} onKeyDown={onKeyDown}>
      <ToastContainer
        limit={5}
        autoClose={60000}
        style={{ visibility: hideToastNotifications ? "hidden" : undefined }}
      />
      <div
        className={clsx(wrapperStyles["div-header-wrapper"])}
        id="Header"
        style={{ height: headerHeight, minHeight: headerHeight }}
      >
        <DashboardNavbar />
      </div>
      <div className={clsx(wrapperStyles["div-workArea-wrapper"])} id="SideBar_FullRightSide">
        <SplitterLocal
          orientation="vertical"
          style={{ width: "100%", height: "100%" }}
          onCollapse={showMenu}
          onExpand={showMenu}
          onResizeEnd={onResizeEnd}
          id="MainSplitter"
          primaryIndex={1}
          sizeSecondary={"245px"}
          collapsed={drawerOpen}
        >
          <div id="CollapsibleSplitterItem" style={{ height: "100%", flex: "1" }}>
            <div
              className={clsx("sidebarStimate", { light: theme === "light" }, wrapperStyles["div-sideBar-wrapper"])}
              id="SideBar"
            >
              <Scrollbars autoHide style={{ overflowX: "hidden" }}>
                <SideBar />
              </Scrollbars>
            </div>
          </div>

          <div
            className={clsx(
              "backgroundColorStimate",
              {
                light: theme === "light",
              },
              wrapperStyles["div-content-wrapper"],
            )}
            id="FullRightSide"
          >
            <FullRightSide drawerBool={!drawerOpen} />
          </div>
        </SplitterLocal>
      </div>
      <StickyFooter />
    </div>
  );
}
